<div class="row justify-content-between" *ngIf="umgebung === 'VIDEX' && currentLang === 'de'">
  <div class="col-md align-content-between pt-2 footer-items-flat">

    <span>
      <span>© 1995-2026 &nbsp;&nbsp;&nbsp;&gt;&nbsp;&nbsp; Auswärtiges Amt</span>
    </span>

    <span>
      &gt;
      <a routerLink="/impressum"
         target="_blank" rel="noopener noreferrer">Impressum</a>
    </span>

    <span>
      &gt;
      <a title="Datenschutz"
         href="https://diplo.de/videxdatenschutz" target="_blank" rel="noopener noreferrer">Datenschutz</a>
    </span>

    <span>
      &gt;
      <a title="Erklärung zur Barrierefreiheit"
         href="https://diplo.de/videxbarrierefreiheitserklaerung" target="_blank" rel="noopener noreferrer">Erklärung zur Barrierefreiheit</a>
    </span>

    <span>
      &gt;
      <a title="Barriere melden"
         href="https://diplo.de/videxbarrierefreiheitfeedback" target="_blank" rel="noopener noreferrer">Barriere melden</a>
    </span>

    <span style="display:block; margin-top: 1em">
      Version: {{ version }}
    </span>

  </div>
  <div class="col-md-2">
    <img src="assets/euLogo_2.jpg" alt="euLogo" style="width:100%;height:100%">
  </div>
</div>

<div class="row justify-content-between" *ngIf="umgebung === 'VIDEX' && currentLang !== 'de'">
  <div class="col-md align-content-between pt-2">
    <div class="row ms-2">
      <span i18n>© 1995-2026 Auswärtiges Amt</span>
    </div>
    <div class="row ms-2">
      <span>Version: {{ version }}</span>
    </div>
  </div>

  <div class="col-md-5 pt-2">
    <div class="row ms-2">
      <a
        title="Auswärtiges Amt"
        href="http://www.auswaertiges-amt.de/{{getLanguagePathForFederalForeignOffice()}}" target="_blank"
        i18n rel="noopener noreferrer">Zur Website des Auswärtigen Amts der Bundesrepublik Deutschland</a>
    </div>

    <div class="row ms-2 pt-1 pb-1">
      <a
        routerLink="/impressum"
        target="_blank"
        rel="noopener noreferrer"
        i18n="@@impressum">Impressum</a>
    </div>


    <div class="row ms-2" [ngSwitch]="currentLang">
      <a *ngSwitchCase="'de'"
         title="Datenschutz"
         href="https://diplo.de/videxdatenschutz" target="_blank" rel="noopener noreferrer"
         i18n>Datenschutz</a>
      <a *ngSwitchDefault
         title="Datenschutz"
         href="https://diplo.de/videxdatenschutz-en" target="_blank" rel="noopener noreferrer"
         i18n>Datenschutz</a>
    </div>
  </div>

  <div class="col-md-2">
    <img src="assets/euLogo_2.jpg" alt="euLogo" style="width:100%;height:100%">
  </div>
</div>


<div class="row justify-content-between pt-2 pb-2" *ngIf="umgebung === 'MEK'">
  <div class="col-md">
    <span i18n>© 1995-2026 Auswärtiges Amt</span>
  </div>
  <div class="col-md text-right">
    <span>Version: {{ version }}</span>
  </div>
</div>

